import React from "react";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import PublicNav from "../components/PublicNav";
import { CalendarClock } from "lucide-react";
import { EconomicCalendar } from "../components/EconomicCalendar";
import { MarketNews } from "./News";

export default function Trading() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      {user ? <Navbar /> : <PublicNav />}
      <main className="max-w-3xl mx-auto px-6 py-16 lg:py-24" data-testid="nfp-page">
        <span className="inline-flex items-center gap-2 text-xs font-mono px-3 py-1 rounded-full bg-amber-500/15 text-amber-400 border border-amber-500/20 mb-6">
          NFP
        </span>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight leading-[1.05] mb-6">
          Calendario economico & <span className="text-amber-400">NFP</span>
        </h1>
        <p className="text-lg text-zinc-300 leading-relaxed flex items-start gap-2">
          <CalendarClock size={22} className="text-amber-400 shrink-0 mt-1" />
          Segui in tempo reale le notizie macroeconomiche ad alto impatto — come il Non-Farm Payrolls (NFP) —
          con previsioni, dati precedenti e valori effettivi.
        </p>

        <EconomicCalendar />

        <MarketNews />
      </main>
    </div>
  );
}
